/**
 * The public (link-based) operator page's calls for drivers and vehicles —
 * exactly what DriverManagementSection / FleetManagementSection always sent,
 * pulled out so the same components can be handed an authenticated
 * `{ list, save, remove }` service by the operator portal instead
 * (src/Services/OperatorPortalApi.js).
 *
 * The public endpoints scope by the `operatorId` in the request, so every
 * call here carries it; the portal's service carries none.
 */
import { get, post, del } from '../../Services/API';

const publicService = (path, operatorId) => ({
  list: async () => {
    const response = await get(path, { operatorId });
    return response.data?.data || [];
  },
  save: (record) => post(path, { ...record, operator_id: operatorId }),
  remove: (id) => del(path, { id, operatorId }),
});

export const publicDriverService = (operatorId) => publicService('operators/drivers-public', operatorId);
export const publicVehicleService = (operatorId) => publicService('operators/cars-public', operatorId);
